import { render, staticRenderFns } from "./liberar_cupo.vue?vue&type=template&id=772fe1ee"
import script from "./liberar_cupo.vue?vue&type=script&lang=js"
export * from "./liberar_cupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports